import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
// import ProfileReducer from "./auth/profile/reducer";

import CategoryReducer from "./2-category/reducer";
import MediaReducer from "./0-media/reducer";
import ProfilesPostReducer from "./4-profile/reducer";
import authReducer from "./auth/login_2/reducer";
import UserReducer from "./1-user/reducer";
import ContactReducer from "./10-contactUs/reducer";
import JobApplicationReducer from "./11-jobApplication/reducer";
import DashboardAnalyticsReducer from "./12-DashboardAnalytics/reducer";
import RankedReducer from "./3-ranked/reducer";
import QuestionReducer from "./5-question/reducer";
import UnrankedReducer from "./6-unranked/reducer";
import PackagesReducer from "./7-package/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Categories: CategoryReducer,
  Ranked: RankedReducer,
  Question: QuestionReducer,
  Account: AccountReducer,
  Unranked: UnrankedReducer,
  Packages: PackagesReducer,
  Media: MediaReducer,
  Profile: ProfilesPostReducer,

  ForgetPassword: ForgetPasswordReducer,
  // Profile: ProfileReducer,
  auth: authReducer,
  Users: UserReducer,
  contact: ContactReducer,
  jobApplication: JobApplicationReducer,
  dashboardAnalytics: DashboardAnalyticsReducer,
});

export default rootReducer;
